import React, { useState } from 'react';
import { addDoc, collection, serverTimestamp } from 'firebase/firestore';
import { db } from '../firebase';

const DedicationForm = () => {
  const [name, setName] = useState('');
  const [message, setMessage] = useState('');
  const [bgColor, setBgColor] = useState('#ffffff');  // Cor de fundo predefinida
  const [textColor, setTextColor] = useState('#000000');  // Cor de texto predefinida
  const [loading, setLoading] = useState(false);

  // Cores predefinidas
  const predefinedColors = {
    background: [
      { name: 'Branco', color: '#ffffff' },
      { name: 'Rosa', color: '#f8d7da' },
      { name: 'Verde', color: '#d4edda' },
      { name: 'Amarelo', color: '#fff3cd' },
      { name: 'Azul Claro', color: '#d1ecf1' }
    ],
    text: [
      { name: 'Preto', color: '#000000' },
      { name: 'Vermelho Escuro', color: '#721c24' },
      { name: 'Verde Escuro', color: '#155724' },
      { name: 'Amarelo Escuro', color: '#856404' },
      { name: 'Azul Escuro', color: '#0c5460' }
    ]
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      await addDoc(collection(db, 'messages'), {
        name: name,
        message: message,
        bgColor: bgColor,
        textColor: textColor,
        createdAt: serverTimestamp(),
      });

      setName('');
      setMessage('');
      setBgColor('#ffffff');
      setTextColor('#000000');
      alert('Mensagem adicionada com sucesso!');
    } catch (error) {
      console.error('Erro ao adicionar mensagem: ', error);
      alert('Erro ao adicionar mensagem');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="container mt-4">
      <h1>Adicionar Dedicação</h1>
      <form onSubmit={handleSubmit}>
        <div className="form-group">
          <label>Nome</label>
          <input
            type="text"
            className="form-control"
            value={name}
            onChange={(e) => setName(e.target.value)}
            maxLength="50"
            required
          />
        </div>
        <div className="form-group">
          <label>Mensagem</label>
          <textarea
            className="form-control"
            value={message}
            onChange={(e) => setMessage(e.target.value)}
            required
          />
        </div>
        <div className="form-group">
          <label>Cor de Fundo do Card</label>
          <div className="d-flex flex-wrap">
            {predefinedColors.background.map((color, index) => (
              <button
                key={index}
                type="button"
                className="btn m-2"
                style={{
                  backgroundColor: color.color,
                  color: '#fff',
                  border: bgColor === color.color ? '2px solid black' : '1px solid #ccc',
                  width: '60px',
                  height: '60px'
                }}
                onClick={() => setBgColor(color.color)}
              >
                {color.name}
              </button>
            ))}
          </div>
        </div>
        <div className="form-group">
          <label>Cor do Texto</label>
          <div className="d-flex flex-wrap">
            {predefinedColors.text.map((color, index) => (
              <button
                key={index}
                type="button"
                className="btn m-2"
                style={{
                  backgroundColor: color.color,
                  color: '#fff',
                  border: textColor === color.color ? '2px solid black' : '1px solid #ccc',
                  width: '60px',
                  height: '60px'
                }}
                onClick={() => setTextColor(color.color)}
              >
                {color.name}
              </button>
            ))}
          </div>
        </div>
        <button type="submit" className="btn btn-primary" disabled={loading}>
          {loading ? 'Enviando...' : 'Enviar'}
        </button>
      </form>

      {/* Pré-visualização do cartão */}
      <h2 className="mt-4">Pré-visualização</h2>
      <div
        className="card mt-3 p-3"
        style={{
          backgroundColor: bgColor,
          color: textColor,
          borderRadius: '10px',
        }}
      >
        <h4>{name || 'Nome aqui'}</h4>
        <p>{message || 'Sua mensagem aqui...'}</p>
      </div>
    </div>
  );
};

export default DedicationForm;